export default __webpack_public_path__ + "static/media/collection.b4b9a201.svg";